import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ConsumptionState {
  searchText: string;
  selectedFilter: string;
  startDate: Date | null;
  endDate: Date | null;
  paginatorPageIndex: number;
  paginatorPageSize: number;
  sortActive: string;
  sortDirection: 'asc' | 'desc' | '';
  scrollPosition: number;
  isActive: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class RestaurantStateService {
  private readonly defaultConsumptionState: ConsumptionState = {
    searchText: '',
    selectedFilter: 'month',
    startDate: null,
    endDate: null,
    paginatorPageIndex: 0,
    paginatorPageSize: 10,
    sortActive: '',
    sortDirection: '',
    scrollPosition: 0,
    isActive: true,
  };

  private consumptionState = new BehaviorSubject<ConsumptionState>(
    this.defaultConsumptionState
  );

  getConsumptionState() {
    return this.consumptionState.asObservable();
  }

  getCurrentConsumptionState(): ConsumptionState {
    return this.consumptionState.value;
  }

  updateConsumptionState(state: Partial<ConsumptionState>) {
    const currentState = this.consumptionState.value;
    this.consumptionState.next({ ...currentState, ...state });
  }

  resetConsumptionState() {
    this.consumptionState.next({ ...this.defaultConsumptionState });
  }
}
